// THE 🏥 BADGE — a small sign floating over the Hospital building (or over home, where the sickbeds are, if there is no Hospital
// yet) showing how many citizens are inside and the worst condition. Click it to visit the Hospital (Events.OpenHospital → the
// pop-up in ui/hospitalChip.js); scene/fieldClicks.js routes the click. Hidden when nobody is in the Hospital.
import * as THREE from 'three'
import { Events, on, emit } from '../ui/eventBus.js'
import { GROUND_Y } from './hexGrid.js'
import { getBuildings } from '../game/buildingState.js'
import { tileToWorld, getHomeTileIndex } from '../game/plotState.js'
import { BuildingTypes, HospitalConfig } from '../config/balance.js'
import * as hospital from '../game/hospital.js'

const TINT = { mild: '#3d6b3d', serious: '#8a6a1e', severe: '#a24a1c', terminal: '#8e1f1a' }

export function createHospitalBadge({ scene }) {
  const canvas = document.createElement('canvas'); canvas.width = 256; canvas.height = 96
  const tex = new THREE.CanvasTexture(canvas); tex.colorSpace = THREE.SRGBColorSpace
  const sprite = new THREE.Sprite(new THREE.SpriteMaterial({ map: tex, transparent: true, depthTest: false }))
  sprite.scale.set(1.05, 0.39, 1); sprite.renderOrder = 5; sprite.visible = false; sprite.name = 'hospital-badge'
  scene.add(sprite)

  function spot() {
    const h = getBuildings().find((b) => b.type === BuildingTypes.HOSPITAL)
    if (h) return tileToWorld(h.tileIndex)
    const home = getHomeTileIndex()
    return home != null ? tileToWorld(home) : null
  }
  function paint(n, worst) {
    const g = canvas.getContext('2d'); g.clearRect(0, 0, 256, 96)
    g.fillStyle = TINT[worst] ?? TINT.mild; g.strokeStyle = '#ffe3d6'; g.lineWidth = 4
    g.beginPath(); g.roundRect(6, 6, 244, 84, 22); g.fill(); g.stroke()
    g.fillStyle = '#fff'; g.font = '700 46px system-ui, sans-serif'; g.textBaseline = 'middle'; g.textAlign = 'center'
    g.fillText(`🏥 ${n}`, 128, 50)
    tex.needsUpdate = true
  }
  function refresh() {
    const n = hospital.count(), p = n ? spot() : null
    sprite.visible = !!(n && p)
    if (!sprite.visible) return
    sprite.position.set(p.x, GROUND_Y + 1.5, p.z)
    paint(n, hospital.worstCondition() ?? 'mild')
  }
  for (const ev of [Events.HospitalChange, Events.BuildingAdded, Events.BuildingRemoved, Events.KingdomChange, Events.AccountStatePulled]) on(ev, refresh)
  setInterval(refresh, 30_000) // the worst condition shifts as the hours pass
  setTimeout(refresh, 1200)
  const api = { sprite, pick: () => (sprite.visible ? [sprite] : []), open: () => { emit(Events.OpenHospital, {}); return true }, refresh }
  if (import.meta.env?.DEV) window.__hospitalBadge = { visible: () => sprite.visible, pos: () => ({ x: +sprite.position.x.toFixed(3), y: +sprite.position.y.toFixed(3), z: +sprite.position.z.toFixed(3) }), refresh, conditions: HospitalConfig.conditions.map((c) => c.id) }
  return api
}
